import React from "react";
import BootstrapModal from "react-bootstrap/Modal";
import { MdClose } from "@react-icons/all-files/md/MdClose";

import "./PremiumUpgradeModal.scss";

interface IProps {
  dialogClassName?: string;
  handleClose: () => void;
  show: boolean;
  body: React.ReactNode;
  header: React.ReactNode;
}

const PremiumUpgradeModal = ({
  show,
  handleClose,
  body,
  header,
  dialogClassName,
}: IProps) => {
  return (
    <BootstrapModal
      dialogClassName={dialogClassName}
      show={show}
      onHide={handleClose}
      centered
    >
      <BootstrapModal.Header className="PremiumUpgradeModal__header">
        <BootstrapModal.Title className="PremiumUpgradeModal__title">
          {header}
        </BootstrapModal.Title>
        <MdClose
          size={24}
          id="close-modal"
          className="PremiumUpgradeModal__closeIcon"
          onClick={handleClose}
        />
      </BootstrapModal.Header>
      <BootstrapModal.Body className="PremiumUpgradeModal__body">
        {body}
      </BootstrapModal.Body>
    </BootstrapModal>
  );
};

export default PremiumUpgradeModal;
